import { ManageClientsActions } from "./manageClientsActions";

export const getClientsPageCMSContent = async () => {
    try {
        const payload = { pagename: "Clients" };
        const res = await ManageClientsActions.getAdminClientsCMSContent(payload);

        if (res?.status === 200 || res?.status === 204) {
            const page = res?.data?.Pages?.find((el) => el?.Key === "Clients");
            if (!page) {
                return null;
            }

            const { Title, Description, TabNavigationTitle, Components } = page;
            return {
                title: Title,
                description: Description,
                tabNavigationTitle: TabNavigationTitle,
                pageContent: Components,
            };
        }

        return null;
    } catch (error) {
        return null;
    }
};
